/**
 * @generated SignedSource<<d88dcaaeec8d3a188c8750ea3ebbdfab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteClientBillToInput = {
  clientBillToId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteClientBillToMutation$variables = {
  input: DeleteClientBillToInput;
};
export type DeleteClientBillToMutation$data = {
  readonly deleteClientBillTo: {
    readonly deletedClientBillToId: string | null;
  } | null;
};
export type DeleteClientBillToMutation$rawResponse = {
  readonly deleteClientBillTo: {
    readonly deletedClientBillToId: string | null;
  } | null;
};
export type DeleteClientBillToMutation = {
  variables: DeleteClientBillToMutation$variables;
  response: DeleteClientBillToMutation$data;
  rawResponse: DeleteClientBillToMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteClientBillToPayload",
    "kind": "LinkedField",
    "name": "deleteClientBillTo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedClientBillToId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteClientBillToMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteClientBillToMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "70edf796a75b9940a00435aea45d94e3",
    "id": null,
    "metadata": {},
    "name": "DeleteClientBillToMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteClientBillToMutation(\n  $input: DeleteClientBillToInput!\n) {\n  deleteClientBillTo(input: $input) {\n    deletedClientBillToId\n  }\n}\n"
  }
};
})();

(node as any).hash = "420e6fe86d704bb7d29da8004ce15508";

export default node;
